import { z } from 'zod';
import { defaulted, mediaRefSchema, objectIdSchema, translatableString } from '../common.js';
/**
 * Blokning ko'rinish sozlamalari — barcha 31 blok turida bir xil.
 * Admin panelning «Ko'rinish sozlamalari» paneliga to'g'ri keladi (Design D4).
 */
export const blockSettingsSchema = z.object({
    paddingTop: z.enum(['none', 'sm', 'md', 'lg']).default('md'),
    paddingBottom: z.enum(['none', 'sm', 'md', 'lg']).default('md'),
    background: z.enum(['white', 'grey', 'dark', 'primary', 'image']).default('white'),
    backgroundImage: mediaRefSchema.nullable().default(null),
    /** Sahifa ichida havola uchun: `#xizmatlar` */
    anchorId: z
        .string()
        .trim()
        .regex(/^[a-z0-9-]*$/, 'Langar faqat kichik harf, raqam va defisdan iborat')
        .max(60)
        .default(''),
    containerWidth: z.enum(['default', 'wide', 'full']).default('default'),
});
/** Har bir blokda bo'ladigan umumiy maydonlar. */
export const blockCommonSchema = z.object({
    /** Blok identifikatori — hujjat ichida noyob. */
    _id: z.string().min(1).max(40),
    order: z.number().int().min(0).default(0),
    isVisible: z.boolean().default(true),
    settings: defaulted(blockSettingsSchema),
});
/**
 * Ro'yxat bloklari uchun umumiy tanlash rejimi.
 * `auto` — avtomatik saralash, `manual` — qo'lda tanlangan elementlar.
 */
export const selectionModeSchema = z.enum(['auto', 'category', 'brand', 'manual', 'featured']);
export const listSelectionSchema = z.object({
    mode: selectionModeSchema.default('auto'),
    /** `mode` = category | brand bo'lganda — tanlangan kategoriya/brend. */
    targetId: objectIdSchema.nullable().default(null),
    /** `mode` = manual bo'lganda — qo'lda tanlangan elementlar tartibi saqlanadi. */
    itemIds: z.array(objectIdSchema).max(40).default([]),
    limit: z.number().int().min(1).max(40).default(6),
});
/** Ro'yxat bloklarining ko'p qismida takrorlanadigan sarlavha + tugma. */
export const listHeaderSchema = z.object({
    title: translatableString({ max: 200 }),
    subtitle: translatableString({ max: 400 }),
    showMoreButton: z.boolean().default(false),
    moreButtonLabel: translatableString({ max: 100 }),
    moreButtonHref: z.string().trim().max(300).default(''),
});
/** Blok ichidagi tugma. */
export const blockCtaSchema = z.object({
    label: translatableString({ max: 120 }),
    href: z.string().trim().max(300).default(''),
});
//# sourceMappingURL=base.js.map